import { Link } from 'react-router-dom';
import Panel from '~/components/Panel';

interface Props {
    fundName: string | null;
    natafid: string | null;
    user_id: number | null;
    campaign_type: string | null;
}

const FundNameBlock: React.FC<Props> = ({
    fundName,
    natafid,
    user_id,
    campaign_type,
}) => {
    const user_dertal_route = `/users/${user_id}`;
    return (
        <>
            <Panel addClasses={`border-[#FFF4DB] bg-[#FFF9EC] flex-1`}>
                <h2 className='text-[16px]/[24px] font-medium uppercase text-[#131212]'>
                    FUND NAME
                </h2>
                {/* Link to User detail */}
                {/* <div className='text-[14px]/[18px] text-[#686868]'>
                    <Link to={user_dertal_route} className='text-[#00AEB3]'>
                        User
                    </Link>
                </div> */}
                <div className='text-[38px]/[44px] font-bold text-[#131212]'>
                    {fundName}
                </div>
                <div className='text-[16px]/[24px] text-[#686868]'>
                    {campaign_type}
                </div>
            </Panel>
        </>
    );
};

export default FundNameBlock;
